import React from 'react';
import PropTypes from 'prop-types';
import { Button, Result } from 'antd';

// Shows a fallback instead of a blank page when a component throws while rendering.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log the error and component stack only; never the store (it holds customer data).
    console.error(error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <Result
        status="error"
        title="Something went wrong"
        subTitle="Reload the page to try again."
        extra={(
          <Button type="primary" onClick={() => window.location.reload()}>
            Reload
          </Button>
        )}
      />
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
